import { Tabs } from 'antd'

export const Tab = Tabs.TabPane
